const instances = new Set();
let nextId = 0;
function createManagedController(Controller, componentName) {
    return class extends Controller {
        constructor() {
            super();
            if (!this.id) {
                nextId += 1;
                this.id = `${componentName.toLowerCase()}-${nextId}`;
            }
        }
        connectedCallback() {
            Controller.prototype.connectedCallback?.call(this);
            if (this.isConnected)
                instances.add(this);
        }
        disconnectedCallback() {
            Controller.prototype.disconnectedCallback?.call(this);
            instances.delete(this);
        }
    };
}
export function defineLpController(tagName, Controller, componentName = tagName.replace(/^lp-/, "")) {
    if (customElements.get(tagName)) {
        return;
    }
    customElements.define(tagName, createManagedController(Controller, componentName));
}
export function getLpControllerInstances() {
    return Array.from(instances);
}
